import {
    DOCX_MIME_TYPES,
    HTML_MIME_TYPES,
    MARKDOWN_MIME_TYPES,
    ZIP_MIME_TYPES,
} from './mime-types';

/**
 * Content types the content import knows how to read.
 */
export const IMPORTABLE_MIME_TYPES = [
    ...ZIP_MIME_TYPES,
    ...MARKDOWN_MIME_TYPES,
    ...HTML_MIME_TYPES,
    ...DOCX_MIME_TYPES,
];

/**
 * Maximum size of a file the content import reads.
 */
export const MAX_IMPORT_FILE_SIZE = 40 * 1024 * 1024;

/**
 * Maximum number of files a single content import reads. Mirrored by the `maxItems` of the API's
 * own `ContentImportSource`.
 */
export const MAX_IMPORT_FILES = 50;

/**
 * Whether a file of this content type can be imported.
 */
export function isImportableContentType(contentType: string): boolean {
    return IMPORTABLE_MIME_TYPES.includes(contentType);
}
